import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { BgFallbackDirective } from '@banyan/commons/directives/bg-img-fallback.directive';
import { ImgFallbackDirective } from '@banyan/commons/directives/src-fallback.directive';
import { HomeHeroComponent } from '@banyan/modules/home/components/home-hero/home-hero.component';
import { HomePageComponent } from '@banyan/modules/home/components/home-page/home-page.component';
import {
  HomePurposeSectionComponent,
} from '@banyan/modules/home/components/home-purpose-section/home-purpose-section.component';
import { HomeRoutingModule } from '@banyan/modules/home/home.routing.module';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';
import { CardComponent } from '@banyan/modules/standalone/card/card.component';
import { GradientComponent } from '@banyan/modules/standalone/gradient/gradient.component';
import { VerticalStepCardComponent } from '@banyan/modules/standalone/vertical-step-card/vertical-step-card.component';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    HomePageComponent,
    HomePurposeSectionComponent,
    HomeHeroComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    HomeRoutingModule,
    ButtonComponent,
    MatIconModule,
    NgOptimizedImage,
    VerticalStepCardComponent,
    GradientComponent,
    CardComponent,
    MatTabsModule,
    SharedModule,
    BgFallbackDirective,
    ImgFallbackDirective,
  ],
})
export class HomeModule {
}
